/**
  * 区块链 接口的统一出口
  */
import axios from '../http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来

//  const api = '/home/'
//  const api = '/c-api/'

const blockchain = {
    // 生产记录
    production(params) {
        return axios.get('/home/b2c/production', { params: params });
    },
    // 扫描记录
    scancode(params) {
        return axios.get('/home/b2c/scancode', { params: params });
    },
    getPlace(params) {
        return axios.get('http://restapi.amap.com/v3/geocode/regeo?key=2fadc174d771223e04524b1e762b38e1&location=116.481488,39.990464&poitype=&radius=&extensions=all&batch=true&roadlevel=0')
    }
};

// 导出接口
export default blockchain;